import ProfileLink from "./profile/ProfileLink.js";
import ProfileRoute from "./profile/ProfileRoute.js";
import ContactLink from "./contact/ContactLink.js";
import ContactRoute from "./contact/ContactRoute.js";
import SecurityLink from "./security/SecurityLink.js";
import SecurityRoute from "./security/SecurityRoute.js";
import NotificationsLink from "./notifications/NotificationsLink.js";
import NotificationsRoute from "./notifications/NotificationsRoute.js";
import PluginSetup from "./plugins/PluginSetup.js";
export default {
  install: molten => {
    PluginSetup.install(molten);
    molten.addPlugin('Action', ProfileLink);
    molten.addPlugin('Route', ProfileRoute);
    molten.addPlugin('Action', ContactLink);
    molten.addPlugin('Route', ContactRoute);
    molten.addPlugin('Action', SecurityLink);
    molten.addPlugin('Route', SecurityRoute);
    molten.addPlugin('Action', NotificationsLink);
    molten.addPlugin('Route', NotificationsRoute);
  }
};